import { render, staticRenderFns } from "./oc-slider-buttons.vue?vue&type=template&id=3dd94328"
import script from "./oc-slider-buttons.vue?vue&type=script&lang=js"
export * from "./oc-slider-buttons.vue?vue&type=script&lang=js"
import style0 from "./oc-slider-buttons.vue?vue&type=style&index=0&id=3dd94328&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports